import {Pipe, PipeTransform} from '@angular/core';

import {DataAttribute} from '../../../views/admin/application-settings/models/data-attribute.model';

@Pipe({
    name: 'ngcPropertyFriendlyNamePipe'
})
export class PropertyFriendlyNamePipe implements PipeTransform {

    transform(propertyName: string = '', attributeList: DataAttribute[]): string {
        let result;
        if (propertyName && attributeList) {
            const attribute = attributeList
                .find((dataAttribute: DataAttribute) => dataAttribute.propertyName === propertyName);
            if (attribute) {
                result = attribute.friendlyName;
            }
        }
        return result || propertyName;
    }

}
